import { gql } from "@apollo/client";

export const GET_OUTFITS_QUERY = gql`
  query GetCurrentUserOutfits {
    getCurrentUser {
      id
      outfits {
        id
        occasion
        imageUrl
        createdAt
        updatedAt
        outfitItems {
          id
          category {
            id
            name
          }
          colors
          style
          description
          imageUrl
        }
      }
    }
  }
`;

export const GET_WARDROBE_ITEMS_QUERY = gql`
  query GetWardrobeItems {
    getCurrentUser {
      id
      outfitItems {
        id
        category {
          id
          name
        }
        item
        colors
        style
        description
        imageUrl
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_WARDROBE_ITEM = gql`
  query GetWardrobeItem($id: ID!) {
    getWardrobeItem(id: $id) {
      success
      outfitItem {
        id
        category {
          id
          name
        }
        colors
        style
        description
        tags
        imageUrl
        createdAt
        updatedAt
      }
      errors {
        fullMessages
      }
    }
  }
`;

export const GET_OUTFITS_BY_ITEM = gql`
  query GetOutfitsByItem($itemId: ID!) {
    getOutfitsByItem(itemId: $itemId) {
      success
      outfits {
        id
        occasion
        imageUrl
        createdAt
        updatedAt
        outfitItems {
          id
          category {
            id
            name
          }
          colors
          style
          description
          imageUrl
        }
      }
      errors {
        fullMessages
      }
    }
  }
`;
